export const texts_es = {
    button: {
        back_to_list: 'Volver a la lista',
        close: 'Cerrar',
        change_password_now: 'Cambiar contraseña ahora',
        delete_patient: 'Borrar paciente',
        delete_user: 'Borrar usuario',
        donwload_report: 'Descargar informe en PDF',
        edit: 'Editar',
        edit_this_patient: 'Editar este paciente',
        edit_this_user: 'Editar este usuario',
        list_view: 'Lista',
        hide_filters: 'Ocultar filtros',
        no_cancel: 'No, cancelar',
        no_take_me_back: 'No, volver atrás',
        report: 'Informe',
        reset_filters: 'Restablecer filtros',
        reset_password: 'Restablecer contraseña',
        save_changes: 'Guardar cambios',
        show_filters: 'Mostrar filtros',
        show_report: 'Mostrar informe',
        table_view: 'Tabla',
        yes_delete: 'Sí, borrar',
        yes_reset_password: 'Sí, restablecer contraseña',
        yes_save_changes: 'Sí, guardar cambios',
    },
    nav: {
        change_password: 'Cambiar contraseña',
        home: 'Inicio',
        legal: 'Información legal',
        patient: {
            list: 'Ver todos los pacientes',
            add: 'Añadir nuevo paciente',
        },
        user: {
            list: 'Ver todos los usuarios',
            add: 'Añadir nuevo usuario',
        },
    },
    login: {
        username: 'Usuario',
        password: 'Contraseña',
        sign_in: 'Conectar',
        sign_out: 'Desconectar',
        incorrect: 'Usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.',
    },
    password: {
        current: 'Contraseña actual',
        has_to_reset_password: '¿Quiere restablecer su contraseña?',
        new1: 'Nueva contraseña',
        new2: 'Nueva contraseña (confirmación)',
        update: 'Actualizar contraseña',
        reset_label: 'Reestablecer contraseña',
        reset_input: 'Introduzca su correo electrónico o nombre de usuario',
        reset_placeholder: 'Correo electrónico o nombre de usuario',
        rule_no_empty:
            'Por favor, rellene los tres campos. El primero con su contraseña actual y los dos siguientes con la nueva contraseña que desea.',
        rule_no_confirmation: 'La nueva contraseña y la contraseña de confirmación no coinciden.',
        rule_too_short: 'La nueva contraseña debe tener al menos 10 caracteres.',
        rule_no_upper: 'La nueva contraseña debe incluir al menos una letra en mayúscula.',
        rule_no_lower: 'La nueva contraseña debe incluir al menos una letra en minúscula.',
        rule_no_number: 'La nueva contraseña debe incluir al menos un número.',
        rule_no_special: 'La nueva contraseña debe incluir al menos un carácter especial.',
    },
    label: {
        accuracy: 'Precisión',
        action_required: 'Acción necesaria',
        add_later: 'Añadir más tarde',
        administrator: 'Administrador',
        age: 'Edad',
        amyloid_pet: 'PET Amiloide',
        apoe_genotype: 'Genotipo ApoE',
        between_0_6: 'Entre 0 y 6',
        between_0_10: 'Entre 0 y 10',
        between_7_12: 'Entre 7 y 12',
        between_11_20: 'Entre 11 y 20',
        between_13_18: 'Entre 13 y 18',
        between_21_30: 'Entre 21 y 30',
        between_55_60: 'Entre 55 y 60',
        between_61_70: 'Entre 61 y 70',
        between_71_80: 'Entre 71 y 80',
        between_81_85: 'Entre 81 y 85',
        cancel: 'Cancelar',
        cdr_must_be_05: 'CDR tiene que ser 0.5',
        cdr_values: '0 = No demencia / 0.5 = Cuestionable / 1 = Leve / 2 = Moderada / 3 = Grave',
        ci: 'IC',
        client: 'Cliente',
        code: 'Código',
        confirm: 'Confirmar',
        completed: 'Completado',
        conclusion: 'Conclusión',
        created: 'Creado',
        download_template: 'Descargar plantilla',
        e4_carrier_non: 'Portador E4 / No portador E4',
        edit_patient: 'Editar paciente',
        edit_user: 'Editar usuario',
        email: 'Email',
        female: 'Mujer',
        first_name: 'Nombre',
        full_name: 'Nombre completo',
        header_ctrl: 'CN %',
        header_mci: 'DCL Estable %',
        header_ad: 'DCL Progresado %',
        import_patients: 'Importar pacientes',
        interpretation: 'Interpretación',
        last_name: 'Apellidos',
        male: 'Hombre',
        male_female: 'Hombre / Mujer',
        maintenance:
            'MAP-AD Test está en mantenimiento en estos momentos. Por favor, inténtelo de nuevo más tarde.',
        mass_upload: 'Carga masiva',
        medical_association: 'Asociación médica',
        medical_position: 'Cargo',
        methylcytosines:
            'El ADN del paciente ha sido utilizado en el proceso de laboratorio del MAP-AD Test Oligos, siguiendo su manual de usuario. Las citosinas mitocondriales metiladas han sido medidas usando el MiSeq® System (Illumina) y analizadas por el MAP-AD Test Software para obtener los resultados.',
        methodology: 'Metodología',
        must_be_0_18: 'Tiene que ser un número entre 0 y 18',
        must_be_0_30: 'Tiene que ser un número entre 0 y 30',
        must_be_1_100000: 'Tiene que ser un número entre 1 y 100000',
        must_be_55_85: 'Tiene que ser un número entre 55 y 85',
        na: 'N/D',
        neurological_conclusion: 'Conclusión neurológica',
        neurologist: 'Neurólogo',
        new_patient: 'Nuevo paciente',
        new_user: 'Nuevo usuario',
        negative: 'Negativo',
        not_available: 'No disponible',
        not_found: 'Página no encontrada (error 404)',
        not_reported: 'No informado',
        password_change: 'Cambio de contraseña',
        password_required_sign_report: 'Contraseña (necesaria para firmar el informe)',
        patient: 'Paciente',
        patients: 'Pacientes',
        pending: 'Pendiente',
        pet: 'PET Amiloide',
        positive: 'Positivo',
        pos_neg: 'Positivo / Negativo',
        prob_ad: 'Probabilidad de EA',
        prob_ctrl: 'Probabilidad de Control',
        prob_mci: 'Probabilidad de DCL',
        prob_non_progressed: 'Probabilidad de No Progresión',
        prob_progressed: 'Probabilidad de Progresión',
        purchased_requests: 'Solicitudes compradas',
        registration_number: 'Número de colegiado',
        report_available: 'Informe disponible',
        req_email: 'Dirección de correo electrónico válida necesaria',
        req_info: 'Información necesaria',
        req_info_2_15_chars: 'Información necesaria (de 2 a 15 caracteres)',
        req_info_2_25_chars: 'Información necesaria (de 2 a 25 caracteres)',
        req_info_5_25_chars: 'Información necesaria (de 5 a 25 caracteres)',
        req_info_7_chars: 'Información necesaria (exactamente 7 caracteres, formato AB12345)',
        result: 'Resultado',
        role: 'Rol',
        search: 'Buscar',
        select_conclusion: 'Selecciona una conclusión',
        sex: 'Sexo',
        signature: 'Firma',
        unknown_role: 'Rol desconocido',
        user_code: 'Código de usuario',
        username: 'Usuario',
        username_required_sign_report: 'Usuario (necesario para firmar el informe)',
        users: 'Usuarios',
        waiting_sample: 'Esperando muestra',
    },
    feedback: {
        cdr_must_be_05:
            'Para predecir la probabilidad de progresión de un paciente es necesario que su CDR sea 0.5.',
        confirm_action: 'Por favor, confirme esta acción',
        confirm_correct: '¿Confirma que es correcto?',
        delete_patient: 'Borrar paciente {{code}} con las siguientes características: {{info}}',
        delete_user: 'Borrar usuario {{user}}',
        email_sent_user:
            'Se ha enviado un correo electrónico a la dirección de correo del usuario con esta información. No necesita hacer nada más al respecto.',
        enter_conclusion: 'Por favor, introduzca su conclusión neurológica.',
        no_patients_meeting_criteria: 'No hay pacientes que cumplan estos criterios.',
        no_users_meeting_criteria: 'No hay usuarios que cumplan estos criterios.',
        not_logged_in:
            'No ha iniciado sesión o su sesión ha caducado. Por favor, inicie sesión para continuar.',
        password_change_required:
            'Necesita cambiar la contraseña temporal que ADmit Therapeutics le ha proporcionado antes de acceder a esta información.',
        password_changed:
            'Su contraseña se ha modificado. Por favor, vuelva a conectarse usando la nueva contraseña.',
        password_not_changed:
            'La contraseña no se ha podido modificar. Por favor, verifique que la contraseña es correcta e inténtelo de nuevo. Contacte con ADmit Therapeutics si necesita ayuda.',
        password_not_reset:
            'La contraseña no se ha podido restablecer. Por favor, pruébelo de nuevo más tarde o contacte con ADmit Therapeutics si necesita ayuda.',
        patient_deleted: 'El paciente {{patient}} se ha borrado con éxito.',
        patient_not_deleted:
            'El paciente no se ha podido borrar. Por favor, pruébelo de nuevo más tarde o contacte con ADmit Therapeutics si necesita ayuda.',
        patient_not_saved:
            'El paciente no se ha podido guardar. Por favor, compruebe que todos los campos se encuentran completos e inténtelo de nuevo. Si el problema persiste, contacte con ADmit Therapeutics para recibir ayuda.',
        patient_saved: 'Nuevo paciente creado con el siguiente código y estas características:',
        pdf_report_not_delivered:
            'No se ha podido descargar el informe en formato PDF. Por favor, inténtelo de nuevo más tarde.',
        please_wait_request_processed:
            'Por favor, espere mientras su petición se está procesando...',
        purchased_requests_exhausted:
            'No es posible crear este paciente porque no le quedan solicitudes. Por favor, contacte con ADmit Therapeutics.',
        purchased_requests_info:
            '{{purchased}} solicitudes compradas – {{created}} pacientes creados – {{left}} solicitudes restantes',
        remember_code_patient:
            'Recuerde que puede consultar el código de cada paciente en su registro.',
        reset_password: 'Restablecer contraseña para el usuario {{user}}',
        select_option: 'Por favor, proceda a seleccionar la opción deseada del menú.',
        session_expired:
            'Su sesión ha caducado. Por favor, vuelva a conectarse o contacte con ADmit Therapeutics si no recuerda su contraseña.',
        sign_report_auth_failed:
            'Autenticación fallida. Por favor, introduzca un usuario y contraseña correctos para firmar este informe.',
        signature_file_required:
            'Para el rol de neurólogo escogido se necesita un archivo que contenga la firma.',
        signature_not_uploaded:
            'El archivo que contiene la firma no se ha podido guardar en el servidor. Por favor, inténtelo de nuevo más tarde o contacte con ADmit Therapeutics si necesita ayuda.',
        user_deleted: 'El usuario {{user}} se ha borrado con éxito.',
        user_not_deleted:
            'El usuario no se ha podido borrar. Por favor, pruébelo de nuevo más tarde o contacte con ADmit Therapeutics si necesita ayuda.',
        user_not_saved:
            'El usuario no se ha podido guardar. Por favor, compruebe que todos los campos se encuentran completos e inténtelo de nuevo. Si el problema persiste, contacte con ADmit Therapeutics para recibir ayuda.',
        user_not_saved_duplicated:
            'El usuario no se ha podido guardar. Por favor, compruebe que no existe otro usuario con el mismo nombre de usuario o dirección de correo electrónico.',
        user_saved:
            'Usuario <strong>{{user}}</strong> creado/actualizado con una contraseña temporal secreta.',
        welcome: 'Bienvenido a MAP-AD Test.',
        will_get_email_results:
            'Recibirá un correo electrónico cuando el resultado de su paciente se encuentre disponible.',
    },
    legal: {
        title: 'Información legal',
        udi: '08437026887117',
        company: 'ADmit Therapeutics',
        focused:
            'Enfocado en la comercialización de una tecnología novel para la detección precoz de la Enfermedad de Alzheimer',
        description:
            'El MAP-AD® Test Software es un componente del dispositivo médico de diagnóstico in vitro (IVD) MAP-AD® Test. MAP-AD es un software dispositivo médico de diagnóstico in vitro cuyo uso previsto es el pronóstico de la Demencia por Enfermedad de Alzheimer en pacientes con deterioro cognitivo leve de 55 a 85 años, mediante la medición de metilcitosinas en el ADN total extraído de sangre humana total y una clasificación cualitativa automática de los sujetos como progresados o no progresados a demencia debido a la Enfermedad de Alzheimer. El MAP-AD® Test Software está destinado a ser utilizado por personal sanitario profesional.',
        version: 'Versión del software',
        serial: 'Número de serie',
        cookies:
            'Este sitio web utiliza sus propias cookies y cookies de terceros para recolectar información con el objetivo de mejorar nuestro servicio. Su uso continuado constituye la aceptación de la instalación de estas cookies. El usuario tiene la opción de configurar el navegador para prevenir la instalación de dichas cookies, aunque esto puede ocasionar dificultades en el uso de la página web.',
        legal_notice: 'Aviso Legal y Protección de Datos',
        legal_notice_text_1: 
            'De conformidad con el RGPD (UE) 2016/679 y la legislación española vigente, le informamos que los datos del profesional usuario de la plataforma y la información seudonimizada del paciente introducida en este software médico son tratados por ADmit Therapeutics S.L. (CIF B67146738, Ctra. Laureà Miró, 408-410, 08980, Sant Feliu de Llobregat, España) en calidad de Encargado del Tratamiento por cuenta del Usuario Solicitante (Responsable del Tratamiento), de acuerdo con las instrucciones documentadas en el contrato de encargo de tratamiento formalizado bajo el Artículo 28 del RGPD. El tratamiento se realiza mediante herramientas automatizadas con la exclusiva finalidad de ejecutar el algoritmo predictivo y reportar el informe de resultados únicamente al usuario solicitante a través de esta plataforma protegida. A tal efecto, se informa la posibilidad de la transferencia de los datos genéticos de secuenciación de nueva generación (NGS), de forma segura, a través del ecosistema en la nube BaseSpace Sequence Hub de Illumina; dicha infraestructura se puede utilizar con la exclusiva finalidad de canalizar la transmisión de los datos para su análisis automatizado mediante el MAP-AD® Test, garantizando rigurosamente la trazabilidad y la calidad de la información obtenida. La base legal que legitima el tratamiento por parte del Responsable es el consentimiento, la ejecución del contrato de servicios sanitarios o el cumplimiento de una misión en interés público (Art. 6.1.a, 6.1.b o 6.1.e del RGPD), habilitado para fines de diagnóstico médico (Art. 9.2.h del RGPD). Los datos y resultados procesados bajo el código de identificación se conservarán en los sistemas durante los plazos legales de custodia aplicables. Dada la naturaleza estrictamente seudonimizada de los datos del paciente (cuya identidad real es totalmente inaccesible para ADmit Therapeutics S.L.), los interesados deberán ejercer sus derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad directamente ante el Usuario Solicitante (Responsable del Tratamiento). Asimismo, se informa del derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).',
        confidentiality_notice: 'Aviso de confidencialidad',
        confidentiality_notice_text_1: 
            'La información visualizada y los informes generados en esta plataforma contienen datos profesionales y médicos de alta sensibilidad y carácter seudonimizado, destinados exclusivamente al profesional sanitario autorizado. Queda estrictamente prohibido el acceso no autorizado, la distribución, la copia o la divulgación de estos contenidos.',
        warnings: 'Advertencias',
        warnings_text_1: 'El MAP-AD Test Software es para uso de diagnóstico in vitro.',
        warnings_text_2:
            'Este software debe ser utilizado únicamente por profesionales de la salud o personal capacitado.',
        precautions: 'Precauciones',
        precautions_text1:
            'No desconecte el ordenador de la toma de corriente o el cable de Internet, ya que no podrá utilizar el software.',
        precautions_text2:
            'Verifique la compatibilidad de su sistema operativo y navegador para asegurarse de que el software pueda funcionar. Nota: JavaScript habilitado es un requisito.',
        precautions_text3:
            'Evite la opción de completar automáticamente el usuario y la contraseña en el navegador, ya que otra persona podría usar su usuario. Nota: En caso de pérdida u olvido del usuario o de la contraseña, póngase en contacto con ADmit Therapeutics.',
        precautions_text4:
            'Evite distracciones cuando introduzca la información en los campos obligatorios, un dato incorrecto potencialmente resultará en un resultado incorrecto para el paciente.',
        precautions_text5:
            'Evite distracciones al registrar el identificador de la muestra o al identificar las muestras físicas, ya que el paciente podría recibir resultados cruzados.',
        precautions_text6:
            'Evite las distracciones al solicitar la creación del usuario, ya que un correo electrónico incorrecto puede provocar que no se reciban actualizaciones del paciente.',
        precautions_text7:
            'Verifique que el IFU se encuentra disponible para su consulta. ADmit Therapeutics le puede proporcionar el IFU bajo petición si es necesario.',
        precautions_text8:
            'Verifique que su usuario y contraseña son correctos. ADmit Therapeutics le puede proporcionar una nueva contraseña bajo petición.',
    },
    mass_upload: {
        confirm_upload: '¿Quiere confirmar la carga masiva de pacientes?',
        upload_completed:
            'Carga masiva de pacientes completada. Revise .txt con identificadores de pacientes',
        upload_completed_file_name: 'ResultadoCargaPacientes',
    },
    error: {
        download_mass_patient_load_template: 'Error descargando plantilla',
        validation_errors_mass_upload_txt_name: 'ErroresValidacionCargaPacientes',
        validation_errors_mass_upload_message:
            'Errores de validación en carga de pacientes. Revisar archivo .txt descargado',
        uploading_errors_mass_upload_txt_name: 'ErroresCargaPacientes',
        uploading_errors_mass_upload_message:
            'Errores en carga en pacientes. Revisar archivo .txt descargado',
        password_reset_failed:
            'Error al restablecer la contraseña. Por favor, inténtelo de nuevo más tarde',
        password_reset_not_found_user:
            'Usuario no encontrado. Por favor, verifique el correo electrónico o nombre de usuario e inténtelo de nuevo',
    },
    reset_password: {
        password_reset_success:
            'La contraseña se ha restablecido con éxito. Revise su correo electrónico',
    },
    patient_report: {
        company_name: 'ADmit Therapeutics S.L.',
        address_line1: 'Ctra Laureà Miró, 408-410',
        address_line2: '08980 Sant Feliu de Llobregat (Barcelona), España',
        phone: 'Teléfono: (34) 931 088 001',
        email: 'mapad@admit-therapeutics.com',
        patient_information: 'INFORMACIÓN DEL PACIENTE',
        patient_id: 'ID del Paciente:',
        age: 'Edad:',
        cdr: 'CDR:',
        sob: 'Puntuación CDR-SOB:',
        apoe: 'Genotipo APOE:',
        user_information: 'INFORMACIÓN DEL USUARIO',
        user: 'Usuario:',
        account: 'Cuenta #:',
        test_report_title: 'Informe de Pronóstico',
        test_result: 'Resultado del test:',
        progressed_score: 'Puntuación de Progresado:',
        non_progressed_score: 'Puntuación de No Progresado:',
        cognitively_normal_score: 'Puntuación de Cognitivamente Normal:',
        category: 'Categoría:',
        interpretation: 'Interpretación:',
        interpretation_explanation:
            'La interpretación de los resultados está sujeta a la valoración y discreción del médico responsable',
        clinical_significance: 'Importancia Clínica:',
        clinical_significance_body1:
            'El MAP-AD® Test proporciona un pronóstico de la demencia debido a enfermedad de Alzheimer (EA) en pacientes de 55 a 85 años que están siendo evaluados por la enfermedad de Alzheimer, mediante la medición de metilcitosinas en ADN total extraído de sangre humana y una clasificación cualitativa automática de los sujetos como progresados o no progresados a demencia debido a enfermedad de Alzheimer.',
        clinical_significance_body2:
            'El resultado está indicado para un uso médico únicamente como marcador de pronóstico. Esta prueba no pretende ser una prueba de detección o de diagnóstico independiente.',
        methodology: 'Descripción de la Metodología:',
        methodology_body1:
            'El ADN de los pacientes es analizado mediante el proceso de laboratorio de los MAP-AD® Test Oligos siguiendo el manual del usuario. La prueba se basa en la medición de las metilcitosinas en las regiones de interés del ADN mitocondrial de la población objetivo como biomarcadores pronósticos de la EA. Las metilcitosinas mitocondriales junto con los datos clínicos (edad, genotipo APOE y puntuación CDR-SOB) han sido analizadas mediante el MAP-AD® Test Software v',
        methodology_body2: ' para obtener los resultados.',
        legal_note: 'Aviso Legal',
        legal_note_body:
            'Este test es un dispositivo de Diagnóstico In Vitro desarrollado por ADmit Therapeutics SL bajo la normativa vigente de IVD para fines clínicos.',
        pdf_version: 'Report v1.0',
        report_date_title: 'Informe emitido en fecha:',
        page_count: 'Página 1 de 1',
    },
};
